export type EscapeLayerPhase = 'capture' | 'bubble';

export interface EscapeKeyEventLike {
    key: string;
    defaultPrevented: boolean;
    target: EventTarget | null;
}

interface EditableCandidate {
    tagName?: unknown;
    type?: unknown;
    isContentEditable?: unknown;
}

const NON_TEXT_INPUT_TYPES: ReadonlySet<string> = new Set([
    'button',
    'checkbox',
    'color',
    'file',
    'hidden',
    'image',
    'radio',
    'range',
    'reset',
    'submit'
]);

// Duck-typed rather than instanceof so it runs without a DOM (node --test).
export function isEditableTarget(target: unknown): boolean {
    if (typeof target !== 'object' || target === null) return false;
    const { tagName, type, isContentEditable } = target as EditableCandidate;
    if (isContentEditable === true) return true;
    if (tagName === 'TEXTAREA' || tagName === 'SELECT') return true;
    return tagName === 'INPUT' && !NON_TEXT_INPUT_TYPES.has(String(type).toLowerCase());
}

// Layers take Escape in document capture, except from an editable element: that gets it first,
// and a layer only sees it in the bubble phase if the element let it through.
export function escapeLayerPhase(event: EscapeKeyEventLike): EscapeLayerPhase | null {
    if (event.key !== 'Escape' || event.defaultPrevented) return null;
    return isEditableTarget(event.target) ? 'bubble' : 'capture';
}
